module.exports = __webpack_public_path__ + "static/01-0a07ce40503d24f2228ca60c71256766.jpg";